import type {IWindowService} from 'angular';
import type {Language} from 'typings/portaro.be.types';

declare global {
    interface Window {
        switchableLanguages: Language[];
    }
}

export class SwitchableLanguagesProvider {
    public static providerName = 'switchableLanguages';

    public readonly $get: (_: IWindowService) => Language[];

    /*@ngInject*/
    constructor(private $windowProvider: IWindowService) {
        this.$get = /*@ngInject*/ ($window: IWindowService) => $window.switchableLanguages;
    }

    public getSwitchableLanguages(): string[] {
        return this.$windowProvider.$get().switchableLanguages;
    }
}